import { ITooltipParams, ValueGetterParams } from "ag-grid-community";
import { get } from "lodash";

import {
  MATCHED_FIELD_LABELS,
  PIC_DELIMITER,
  SideLoadedBusinessRow,
} from "constants/sideLoadedBusinesses";

const getPics = ({
  data,
  colDef,
}: ValueGetterParams | ITooltipParams): string[] => {
  const field = colDef && "field" in colDef ? colDef.field : undefined;
  if (!data || !field) return [];
  const value: string = get(data, field);
  if (!value) return [];
  return value.split(PIC_DELIMITER).filter(Boolean);
};

export const sideLoadedPicsValueGetter = (params: ValueGetterParams): string =>
  getPics(params).join(", ");

export const sideLoadedPicsTooltipValueGetter = (
  params: ITooltipParams,
): string => getPics(params).join(", ");

export const sideLoadedMatchedFieldsTooltipValueGetter = ({
  data,
}: ITooltipParams<SideLoadedBusinessRow>): string => {
  const matchedFields = data?.matchedFields;
  if (!matchedFields?.length) return "";
  return `Matched via ${matchedFields
    .map(field => MATCHED_FIELD_LABELS[field])
    .join(", ")}`;
};
